<template>
    <div>
        <el-select class="search_select search_inputBox search_inputBox_long" :disabled="disableinput" v-model="customer_id" @change="changeCustomer" collapse-tags :multiple="multiple" remote :remote-method="getCustomer" filterable placeholder="客户名称" @visible-change="getCustomer('')">
            <el-option v-for="list in customer" :key="list.id" :value="list.id" :label="list.name"></el-option>
        </el-select>
    </div>
</template>
<script>
export default {
    props:['id','salesman_id','multiple','disableinput'],
    data(){
        return {
            customer:[],
            customer_id:"",
            keyword:""
        }
    },
    created(){
        this.getCustomer()
    },
    methods:{
        changeCustomer(e){
            this.$emit("changeselect",this.customer_id)
        },
        getCustomer(e){
            let arr = [];
            if(this.customer_id){
                if(Array.isArray(this.customer_id)){
                    arr = this.customer_id;
                }else{
                    arr.push(this.customer_id)
                }
            }
            this.postFunc("/erp/customer.select",{keyword:e,id:arr,salesman_id:this.salesman_id},res=>{
                this.customer = res.data.data;
            })
        },
        clearData(){
            this.customer_id = "";
        }

    },
    watch:{
        "id":{
            immediate:true,
            handler:function(val){
                this.customer_id = val;
                this.getCustomer()
            }
        },
        "salesman_id":{
            immediate:true,
            handler:function(){
                this.getCustomer()
            }
        },
        "disableinput":function(val){
        }
    }
}
</script>
<style scoped>

</style>